module.exports = __webpack_public_path__ + "img/pic-paging-service4-1.160b181d.jpg";